import { CommunitySummary } from '@quick/client';
import React from 'react';
import AvatarStatus from '../../../components/shared-components/AvatarStatus';
import Icon, { ForestIcon } from './Icon';

interface CommunityInfoOverviewProps {
  community: CommunitySummary;
  hideAddress?: boolean;
}

const CommunityInfoOverview: React.FC<CommunityInfoOverviewProps> = ({ hideAddress, community }) => {
  return (
    <AvatarStatus
      icon={<Icon name={communityAvatar(community.communityId)} />}
      type="primary"
      name={<span className="label-s">{community.name}</span>}
      subtitle={!hideAddress ? community.address : undefined}
    />
  );
};

const communityAvatar = (communityId: number): ForestIcon => {
  const avatarNumber = (communityId % 8) + 1;
  return `community-avatar-${avatarNumber}` as ForestIcon;
};

export default CommunityInfoOverview;
